import { IStore } from '../../../index';

export const getRound = async (state: IStore, eventId: number) => {
  const rounds = state.events[eventId].rounds;
  return {
    eventRounds: { ...state.eventRounds, rounds }
  };
};
